/*eslint-disable*/
import api from '../'

class scannerGameItems {
    // GET: items
    static getItemsByRequest (params) {
        return api.axios.post('/scannerItemsByRequest', params).then(response => response.data.items);
    }
}

export default scannerGameItems;
